import Component from './Footer';

export default Component;
